import API from '../../../hooks/api';
import { localStorageHelper } from '../../../hooks/localStorageHelper';
import { PROFILE_KEY } from '../../../utils/Constants';
import { userLoginData } from './ScreenHelper';

// The access token is set by the backend as a cookie; only roles/groups are kept client-side.
export const loginAPIv5 = async (
        data: userLoginData,
        callBack: (success: boolean, errorMsg: string | null) => void = () => {}
    ) => {
    await API.post("/operations/v5/login", {
        uid: data?.email,
        password: data?.password,
    }, { withCredentials: true })
    .then((res) => {
        localStorageHelper.store(PROFILE_KEY, { roles: res?.data?.roles, groups: res?.data?.groups });
        callBack(true, null);
    })
    .catch((err) => {
        callBack(false, err);
    });
}
